import ChannelQ from '@/queries/ChannelQ'
import WorldQ from '@/queries/WorldQ'
import type { Query } from '@/client/query'

import type { ChannelBase, WorldBase } from '../../types'

export function channelBaseFromQuery({ channel }: { channel: Query }): ChannelBase {
  return {
    id: channel(ChannelQ.id) ?? 0,
    title: channel(ChannelQ.title) ?? '',
    type: channel(ChannelQ.type) ?? 'discussion',
    worldLevel: channel(ChannelQ.world_level),
  }
}

export function worldBaseFromQuery({ world }: { world: Query }): WorldBase {
  return {
    id: world(WorldQ.id) ?? 0,
    title: world(WorldQ.title) ?? '',
    slug: world(WorldQ.slug) ?? '',
    iconUrl: world(WorldQ.icon_url) ?? '',
    primaryColor: world(WorldQ.primary_color) ?? '',
  }
}
